import { ImageIcon } from "shared-components/Components/CustomIcons/ImageIcon/web"

export const MapCardSkeleton = () => {
    return (
        <div className="property-card-skeleton">
            <div className="map-card__gallery">
                <div className="image"><ImageIcon /></div>
            </div>
            <div className="map-card__content">
                <span style={{ width: '38%' }}></span>
                <span></span>
                <span></span>
                <span style={{ width: '61%' }}></span>
            </div>
        </div>
    )
}